/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgResize = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 12v10h10v-2H4v-8zm6.638 1.948L7.31 15.275l1.414 1.414 1.327-1.327zm3.319-3.32-1.328 1.33 1.415 1.413 1.327-1.328zM12 2v2h8v8h2V2zm3.276 5.31-1.328 1.327 1.414 1.414 1.328-1.327z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgResize as Resize };
